var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataBackup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C7AF3E;}\r\n\t.st1{fill:#2D629B;}\r\n\t.st2{fill:#3778C6;}\r\n\t.st3{fill:#E3C84C;}\r\n\t.st4{fill:#4B95FF;}\r\n\t.st5{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.4,43.3V30.3c0-1.4,1.2-2.6,2.6-2.6h8.6l20.7,6H84c1.4,0,2.6,1.2,2.6,2.6v6.9H43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.3,22.6v20.7c0,1.4-4.6,2.6-10.3,2.6c-5.7,0-10.3-1.2-10.3-2.6V22.6H75.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 65,
    cy: 22.6,
    rx: 10.3,
    ry: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.6,36.4c0,1.4,4.6,2.6,10.3,2.6c5.7,0,10.3-1.2,10.3-2.6v-6.9c0,1.4-4.6,2.6-10.3,2.6 c-5.7,0-10.3-1.2-10.3-2.6V36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.2,70H46.8c-1.2,0-2.3-0.8-2.6-2L40,45.3c-0.2-1.4,0.7-2.6,2.1-2.8c0.2,0,0.3,0,0.5,0h44.8 c1.4-0.1,2.5,1,2.6,2.4c0,0.2,0,0.3,0,0.5L85.7,68C85.4,69.2,84.4,70,83.2,70z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.7,29.2C60.7,29.2,60.6,29.2,60.7,29.2c-0.7-0.1-1.3-0.2-1.9-0.3c-0.5-0.1-0.8-0.5-0.7-1s0.5-0.8,1-0.7 c0.5,0.1,1.1,0.2,1.7,0.2c0.5,0.1,0.8,0.5,0.8,1C61.5,28.9,61.1,29.2,60.7,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65,29.5c-0.3,0-0.6,0-0.9,0c-0.5,0-0.9-0.4-0.8-0.9c0-0.5,0.4-0.8,0.9-0.8c0.6,0,1.1,0,1.7,0 c0.5,0,0.9,0.4,0.9,0.8c0,0.5-0.4,0.9-0.8,0.9C65.6,29.5,65.3,29.5,65,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M69.3,29.2c-0.5,0-0.9-0.4-0.9-0.9c0-0.4,0.3-0.8,0.8-0.9c0.6-0.1,1.1-0.1,1.7-0.2c0.5-0.1,0.9,0.2,1,0.7 s-0.2,0.9-0.7,1l0,0C70.6,29.1,70,29.2,69.3,29.2C69.4,29.2,69.3,29.2,69.3,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.7,36.1C60.7,36.1,60.6,36.1,60.7,36.1c-0.7-0.1-1.3-0.2-1.9-0.3c-0.5-0.1-0.8-0.5-0.7-1s0.5-0.8,1-0.7 c0.5,0.1,1.1,0.2,1.7,0.2c0.5,0.1,0.8,0.5,0.8,1C61.5,35.8,61.1,36.1,60.7,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65,36.4c-0.3,0-0.6,0-0.9,0c-0.5,0-0.9-0.4-0.8-0.9c0-0.5,0.4-0.8,0.9-0.8c0.6,0,1.1,0,1.7,0 c0.5,0,0.9,0.4,0.9,0.8c0,0.5-0.4,0.9-0.8,0.9C65.6,36.4,65.3,36.4,65,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M69.3,36.1c-0.5,0-0.9-0.4-0.9-0.9c0-0.4,0.3-0.8,0.8-0.9c0.6-0.1,1.1-0.1,1.7-0.2c0.5-0.1,0.9,0.2,1,0.7 s-0.2,0.9-0.7,1C70.6,36,70,36.1,69.3,36.1C69.4,36.1,69.3,36.1,69.3,36.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M65,45.9c-5.2,0-9.5,4.2-9.5,9.5c0,5.1,4,9.3,9.2,9.5L63.5,66c-0.3,0.3-0.4,0.9,0,1.2s0.9,0.4,1.2,0 c0,0,0,0,0,0l2.6-2.6c0.3-0.3,0.3-0.9,0-1.2l-2.6-2.6c-0.3-0.3-0.9-0.3-1.2,0c-0.3,0.3-0.3,0.9,0,1.2l1.1,1.1 c-4.3-0.2-7.6-3.9-7.3-8.1c0.2-4.3,3.9-7.6,8.1-7.3s7.6,3.9,7.3,8.1c-0.1,1.5-0.6,3-1.5,4.3c-0.3,0.4-0.2,0.9,0.2,1.2 c0.4,0.3,0.9,0.2,1.2-0.2c0,0,0,0,0,0c3.1-4.2,2.3-10.1-1.9-13.3C69,46.5,67.1,45.9,65,45.9L65,45.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataBackup);
export default __webpack_public_path__ + "static/media/DataBackup.6018dd5ac722e9458d5b96f58105bd37.svg";
export { ForwardRef as ReactComponent };